export default __webpack_public_path__ + "static/media/Joy.04f87881.svg";